/* Find My Pit — client-side quiz.
   Design: Design/FindMyPit_Quiz_Design_v1.md.
   - Four questions -> scoring -> single recommended bundle.
   - Kaching auto-applies refill ladder at cart; we DISPLAY the outcome.
   - Klaviyo Client API: track event + subscribe to list on result render.
   - localStorage: partial answers under 'ecofuego.quiz.v1'.
*/
(function () {
  'use strict';

  var STORAGE_KEY = 'ecofuego.quiz.v1';
  var KLAVIYO_REVISION = '2024-10-15';

  var QUESTIONS = [
    {
      id: 'frequency',
      title: 'How often will you use it?',
      opts: [
        { v: 'sometimes',    strong: 'Now and then',     small: 'A handful of nights across the season.' },
        { v: 'most_weeks',   strong: 'Most weeks',       small: 'A night or two most weeks when the weather’s good.' },
        { v: 'all_the_time', strong: 'All the time',     small: 'Year-round, whenever we’re outside.' }
      ]
    },
    {
      id: 'setting',
      title: 'Where will it live?',
      opts: [
        { v: 'table',  strong: 'On a table', small: 'A balcony, a patio table or a small space.' },
        { v: 'patio',  strong: 'On the patio, deck or balcony', small: 'A fixed spot at home.' },
        { v: 'garden', strong: 'Out in the garden or a larger outdoor space', small: 'Room to breathe, guests around.' },
        { v: 'travel', strong: 'Wherever we go', small: 'Camping, friends’, on trips.' }
      ]
    },
    {
      id: 'travel',
      title: 'Travelling with it?',
      opts: [
        { v: 'no',        strong: 'No — it stays put',   small: 'At home.' },
        { v: 'sometimes', strong: 'Sometimes',                small: 'The odd trip or a move around the garden.' },
        { v: 'regularly', strong: 'Yes — regularly',     small: 'On the road with us.' }
      ]
    },
    {
      id: 'surface',
      title: 'What’s it sitting on?',
      opts: [
        { v: 'wood_composite',       strong: 'Wood decking, composite, or a rug/turf', small: 'Something I want to protect.' },
        { v: 'stone_tile_concrete',  strong: 'Stone, tile, concrete or gravel',        small: 'Nothing to worry about.' },
        { v: 'grass_mix',            strong: 'Grass, or a mix',                        small: 'Not entirely sure.' }
      ]
    }
  ];

  // Currency symbol of the current market, set on the root by the section (was a hard-coded £,
  // so the US page priced the quiz in pounds).
  var CURRENCY = '£';
  function money(n) {
    return CURRENCY + n.toFixed(2);
  }

  /*
    El Niño (launched 2026-10-13). A table top pit with its own 1kg refill, so it gets its own
    package: the pit (one Natural refill is in the box) plus one El Niño refill duo. Offer changed
    14 Oct 2026 (Tim): no duo discount; the pit + duo ships free instead (UK mainland rate is free
    from £100, US carrier service bundle 7). The 50% automatic discount was deactivated the same day.
  */
  var NINO_DUO_PCT = 0;
  // False when El Niño is unpublished (all_products returns blank, so its price renders 0):
  // the 'On a table' answer is hidden and a saved 'table' answer falls back to El Campo.
  // Pulled 2026-10-14 (Tim): the page goes back up when the relaunch is ready.
  var NINO_LIVE = true;

  function save(state) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ answers: state.answers, ts: Date.now() })); } catch (e) {}
  }
  function loadSaved() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      if (!d || !d.answers) return null;
      // 14-day expiry per design.
      if (Date.now() - (d.ts || 0) > 14 * 24 * 3600 * 1000) return null;
      return d.answers;
    } catch (e) { return null; }
  }
  function clearSaved() { try { localStorage.removeItem(STORAGE_KEY); } catch (e) {} }

  function scorePit(a) {
    // Dominant rules. A table is El Niño whatever the other answers say: neither of the
    // big pits belongs on one.
    if (a.setting === 'table') return NINO_LIVE ? 'ENO' : 'ECP';
    if (a.setting === 'travel' || a.travel === 'regularly') return 'ECP';
    var fuego = 0, campo = 0;
    if (a.frequency === 'sometimes')   campo += 1;
    if (a.frequency === 'most_weeks')  { fuego += 1; campo += 1; }
    if (a.frequency === 'all_the_time') fuego += 2;
    if (a.setting === 'patio')  { fuego += 1; campo += 1; }
    if (a.setting === 'garden') fuego += 2;
    // setting travel handled by dominant rule above
    if (a.travel === 'no')        fuego += 1;
    if (a.travel === 'sometimes') campo += 1;
    if (fuego > campo) return 'EF';
    if (campo > fuego) return 'ECP';
    // tie-break by frequency
    if (a.frequency === 'sometimes') return 'ECP';
    return 'EF';
  }

  function fuelCount(a) {
    return a.frequency === 'sometimes' ? 2 : 4;
  }

  function baseNeeded(a) {
    if (a.surface === 'wood_composite') return 'yes';
    if (a.surface === 'stone_tile_concrete') return 'no';
    return 'suggest';
  }

  function buildRecommendation(a, opts) {
    opts = opts || {};
    var pit = scorePit(a);
    var fuelN = fuelCount(a);
    var citronella = !!opts.citronella;
    if (pit === 'ENO') {
      return {
        pitSku: 'ENO-BK',
        pitFamily: 'ENO',
        fuelSku: citronella ? 'RL-ENO-CT-2' : 'RL-ENO-NL-2',
        fuelCount: 1,
        ladderPct: NINO_DUO_PCT,
        addBase: false,       // a heat base is in the El Niño box
        baseRule: 'no',
        citronella: citronella,
        subscription: false
      };
    }
    var pitSku;
    if (pit === 'EF') {
      // Q4 wood/composite -> soft nudge to graphite grey (matches base finish)
      pitSku = a.surface === 'wood_composite' ? 'EF-BK' : 'EF-WD';
    } else {
      pitSku = 'ECP-BK';
    }
    var fuelSku = citronella ? 'RL-CT' : 'RL-NL';
    /*
      Ladder percentages come from the page, not from this file.

      sections/find-my-pit.liquid renders ecofuego.pricing_rules for the CURRENT market into
      data-ladder-2 / data-ladder-4 on the quiz root. Hardcoding 10 / 15 here made this the
      seventh copy of a number that has to match a Kaching rule nobody can query, and it was the
      only copy in JavaScript, so it could not even be changed from the theme editor.

      Absent or unparseable resolves to 0 — claim no discount rather than promise one that may
      not be running.
    */
    var ladderPct = fuelN >= 4 ? LADDER.four : (fuelN >= 2 ? LADDER.two : 0);
    var base = baseNeeded(a);
    // A market that does not stock the Protection Base renders it at price 0 (no product in
    // that catalogue): never offer it there. The US is the case today.
    var bv = (opts.variants || {})['ECP-B-BK'];
    if (!bv || !(bv.price > 0)) base = 'no';
    var addBase = base === 'yes' || (base === 'suggest' && opts.baseChecked !== false);
    return {
      pitSku: pitSku,
      pitFamily: pit,
      fuelSku: fuelSku,
      fuelCount: fuelN,
      ladderPct: ladderPct,
      addBase: addBase,
      baseRule: base,
      citronella: citronella,
      subscription: (a.frequency === 'most_weeks' || a.frequency === 'all_the_time')
    };
  }

  function assembleWhy(a, rec, variants) {
    if (rec.pitFamily === 'ENO') {
      return 'El Niño is the table top one: 18cm across, with its own lid, heat base and carry bag. '
        + 'It burns a 1kg block of wax for 5–7 hours, and one Natural refill comes in the box. '
        + 'Add a refill duo so the next few evenings are covered.';
    }
    var s1 = rec.pitFamily === 'EF'
      ? 'El Fuego is the flagship — the original wax-fuel pit that started ECOFUEGO, built for a permanent spot outside and an eight-hour clean burn.'
      : 'El Campo is the compact one — same 8-hour burn, same wood smoke-free flame, sized to go where you go.';
    var s2 = ({
      patio:  'On a patio or deck it holds the space without dominating it.',
      garden: 'Out in the garden it holds a circle of chairs and doesn’t need tending.',
      travel: 'It packs down, moves easily, and lights the same in a field as on a lawn.'
    })[a.setting];
    var s3 = ({
      sometimes:    'Two refills to start — that’s roughly a fortnight of evenings.',
      most_weeks:   'Four refills gets you through a season of most-weeks use, with 15% off for buying four.',
      all_the_time: 'Four refills to start, then Quarterly Delivery means one turns up before you run out — cancel any time.'
    })[a.frequency];
    return s1 + ' ' + s2 + ' ' + s3;
  }

  function headline(a, rec) {
    if (rec.pitFamily === 'ENO') return 'Your fire is El Niño.';
    if (rec.pitFamily === 'ECP' && a.setting === 'travel') return 'Your fire is El Campo — and it travels.';
    return rec.pitFamily === 'EF' ? 'Your fire is El Fuego.' : 'Your fire is El Campo.';
  }

  function bundleLines(rec, variants) {
    var lines = [];
    var pitV = variants[rec.pitSku];
    lines.push({ sku: rec.pitSku, title: pitV.title, meta: pitV.meta, img: pitV.img, qty: 1, unit: pitV.price, subtotal: pitV.price, save: 0 });
    var fV = variants[rec.fuelSku];
    var fuelSubtotalRaw = fV.price * rec.fuelCount;
    var fuelSaved = fuelSubtotalRaw * (rec.ladderPct / 100);
    var fuelSubtotal = fuelSubtotalRaw - fuelSaved;
    var fuelNote = rec.pitFamily === 'ENO'
      ? (rec.ladderPct ? 'save ' + money(fuelSaved) + ' (' + rec.ladderPct + '% off with the pit, applied at cart)' : '')
      : rec.fuelCount + ' × ' + money(fV.price)
        + (rec.ladderPct ? ' · save ' + money(fuelSaved) + ' (' + rec.ladderPct + '% off at cart, Kaching ladder)' : '');
    lines.push({ sku: rec.fuelSku, title: rec.pitFamily === 'ENO' ? fV.title : fV.title + ' × ' + rec.fuelCount, meta: fV.meta + (fuelNote ? ' · ' + fuelNote : ''), img: fV.img, qty: rec.fuelCount, unit: fV.price, subtotal: fuelSubtotal, save: fuelSaved });
    if (rec.addBase) {
      var bV = variants['ECP-B-BK'];
      lines.push({ sku: 'ECP-B-BK', title: bV.title, meta: bV.meta + (rec.pitSku === 'EF-WD' ? ' · finish is matte black, sits neatly under the pit' : ''), img: bV.img, qty: 1, unit: bV.price, subtotal: bV.price, save: 0 });
    }
    return lines;
  }

  function total(lines) {
    return lines.reduce(function (t, l) { return t + l.subtotal; }, 0);
  }
  function totalSaved(lines) {
    return lines.reduce(function (t, l) { return t + l.save; }, 0);
  }

  function h(tag, attrs, children) {
    var el = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (k === 'class') el.className = attrs[k];
        else if (k === 'html') el.innerHTML = attrs[k];
        else if (k.slice(0, 2) === 'on') el.addEventListener(k.slice(2).toLowerCase(), attrs[k]);
        else el.setAttribute(k, attrs[k]);
      }
    }
    (children || []).forEach(function (c) {
      if (c == null) return;
      if (typeof c === 'string') el.appendChild(document.createTextNode(c));
      else el.appendChild(c);
    });
    return el;
  }

  // Product thumbnail for a bundle line. Returns null when the SKU resolved no
  // image, so the row falls back to the text-only layout rather than a gap.
  function thumb(src, alt) {
    if (!src) return null;
    return h('div', { class: 'fmp__line-img' }, [
      h('img', { src: src, alt: alt || '', loading: 'lazy', decoding: 'async' })
    ]);
  }

  // Per-market ladder, rendered onto the root by the section. See buildRecommendation().
  var LADDER = { two: 0, four: 0 };
  function readLadder(root) {
    if (!root) return;
    LADDER = {
      two: parseInt(root.getAttribute('data-ladder-2'), 10) || 0,
      four: parseInt(root.getAttribute('data-ladder-4'), 10) || 0
    };
  }

  function initInstance(root) {
    readLadder(root);
    CURRENCY = root.getAttribute('data-currency') || '£';
    var booted = false;   // true once the first render has happened — see renderGate()
    var variants = JSON.parse(root.getAttribute('data-variants'));
    NINO_LIVE = !!(variants['ENO-BK'] && variants['ENO-BK'].price > 0);
    var klaviyoKey = root.getAttribute('data-klaviyo-key');
    var listId = root.getAttribute('data-list-id');
    var emailGate = root.getAttribute('data-email-gate') === '1';
    var stage = root.querySelector('[data-fmp-stage]');

    var state = {
      step: 0,          // -1 start, 0..3 questions, 4 email, 5 result
      answers: {},
      opts: { citronella: false, baseChecked: true },
      email: '',
      submitting: false
    };

    var saved = loadSaved();
    if (saved && Object.keys(saved).length > 0) {
      state.answers = saved;
    }

    function render() {
      stage.innerHTML = '';
      if (state.step < 0) return renderStart();
      if (state.step < QUESTIONS.length) return renderQuestion(state.step);
      if (state.step === QUESTIONS.length && emailGate) return renderGate();
      return renderResult();
    }

    function renderStart() {
      var wrap = h('div', { class: 'fmp__start' }, [
        h('button', {
          class: 'fmp__btn fmp__btn--primary fmp__btn--large',
          type: 'button',
          onclick: function () { state.step = 0; render(); }
        }, ['Start']),
        h('p', { class: 'fmp__micro', html: 'Takes ~30 seconds.<br>Get a package sized to how you actually use it.' })
      ]);
      stage.appendChild(wrap);
      if (saved && Object.keys(saved).length > 0) {
        var resume = h('button', {
          class: 'fmp__skip',
          type: 'button',
          onclick: function () {
            state.step = Math.min(Object.keys(state.answers).length, QUESTIONS.length);
            render();
          }
        }, ['Resume where you left off']);
        wrap.appendChild(resume);
      }
    }

    function renderQuestion(i) {
      var q = QUESTIONS[i];
      var current = state.answers[q.id];
      var progress = h('div', { class: 'fmp__progress' });
      for (var j = 0; j < QUESTIONS.length; j++) {
        progress.appendChild(h('span', { class: j <= i ? 'is-active' : '' }));
      }
      var opts = h('div', { class: 'fmp__opts' }, q.opts.filter(function (o) { return NINO_LIVE || o.v !== 'table'; }).map(function (o) {
        return h('button', {
          class: 'fmp__opt' + (current === o.v ? ' is-selected' : ''),
          type: 'button',
          onclick: function () {
            state.answers[q.id] = o.v;
            save(state);
            if (i < QUESTIONS.length - 1) state.step = i + 1;
            else state.step = QUESTIONS.length;
            render();
          }
        }, [
          h('strong', {}, [o.strong]),
          h('span', {}, [o.small])
        ]);
      }));
      var nav = h('div', { class: 'fmp__nav' }, [
        i > 0 ? h('button', {
          class: 'fmp__back',
          type: 'button',
          onclick: function () { state.step = i - 1; render(); }
        }, ['← Back']) : h('span', {}, ['']),
        h('span', { class: 'fmp__micro', style: 'font-size:12px;color:var(--fmp-muted);' }, ['Question ' + (i + 1) + ' of ' + QUESTIONS.length])
      ]);
      var card = h('div', { class: 'fmp__q' }, [
        progress,
        h('h3', { class: 'fmp__q-title' }, [q.title]),
        opts,
        nav
      ]);
      stage.appendChild(card);
    }

    function renderGate() {
      var errEl;
      var input = h('input', { type: 'email', placeholder: 'you@example.com', autocomplete: 'email', inputmode: 'email' });
      var card = h('div', { class: 'fmp__gate' }, [
        h('h3', {}, ['One last thing.']),
        h('p', {}, ['We’ll email your recommendation so you have it later. No spam, unsubscribe any time.']),
        input,
        errEl = h('div', { class: 'fmp__error' }, ['']),
        h('button', {
          class: 'fmp__btn fmp__btn--primary fmp__btn--full',
          type: 'button',
          onclick: function () {
            var v = (input.value || '').trim();
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
              errEl.textContent = 'That doesn’t look like a valid email.';
              return;
            }
            state.email = v;
            state.step = QUESTIONS.length + 1;
            render();
          }
        }, ['See my pit →']),
        h('button', {
          class: 'fmp__skip',
          type: 'button',
          onclick: function () {
            state.email = '';
            state.step = QUESTIONS.length + 1;
            render();
          }
        }, ['Skip — just show me the recommendation'])
      ]);
      stage.appendChild(card);
      /*
        NEVER FOCUS ON THE BOOT RENDER.

        Focusing an element scrolls it into view. The quiz resumes where the visitor left off, so
        anyone who had previously reached the email gate came back to the HOMEPAGE and was
        yanked down the page to the quiz before they had read a word of it (reported by Gabe,
        2026-09-22: "why is the homepage auto-scrolling to the quiz?"). It only reproduced for
        people with saved answers, which is why it survived review — everyone testing a fresh
        session saw nothing wrong.

        Focus is right when the gate appears BECAUSE the visitor just answered the last question.
        It is wrong when the gate is simply what the page happens to open on.
      */
      if (booted) {
        setTimeout(function () { try { input.focus(); } catch (e) {} }, 30);
      }
    }

    function renderResult() {
      state.opts.variants = variants;
      var rec = buildRecommendation(state.answers, state.opts);
      var lines = bundleLines(rec, variants);
      var pkgTotal = total(lines);
      var pkgSave = totalSaved(lines);
      var hl = headline(state.answers, rec);
      var why = assembleWhy(state.answers, rec, variants);

      // Fire Klaviyo (best-effort, non-blocking) — once per result render.
      fireKlaviyo(state.answers, rec, pkgTotal, state.email);

      var linesDom = h('div', {}, lines.map(function (l) {
        return h('div', { class: 'fmp__line' }, [
          thumb(l.img, l.title),
          h('div', { class: 'fmp__line-body' }, [
            h('strong', {}, [l.title]),
            h('span', {}, [l.meta])
          ]),
          h('div', { class: 'fmp__line-price' }, [money(l.subtotal)])
        ]);
      }));

      var toggleCit = h('label', { class: 'fmp__toggle' + (state.opts.citronella ? ' is-on' : '') }, [
        h('input', {
          type: 'checkbox',
          checked: state.opts.citronella ? 'checked' : null,
          onchange: function (e) { state.opts.citronella = e.target.checked; render(); }
        }),
        h('div', {}, [
          h('strong', {}, ['Bugs a problem?']),
          document.createTextNode(rec.pitFamily === 'ENO'
            ? ' Make the duo Citronella (+' + money(Math.max(0, variants['RL-ENO-CT-2'].price - variants['RL-ENO-NL-2'].price)) + ').'
            : ' Swap one refill for Citronella (+' + money(Math.max(0, variants['RL-CT'].price - variants['RL-NL'].price)) + ' per refill).')
        ])
      ]);
      // Clean up checked attribute (setAttribute would coerce). Set property directly:
      toggleCit.querySelector('input').checked = state.opts.citronella;

      var toggleBase = null;
      if (rec.baseRule === 'suggest') {
        toggleBase = h('label', { class: 'fmp__toggle' + (state.opts.baseChecked !== false ? ' is-on' : '') }, [
          h('input', {
            type: 'checkbox',
            onchange: function (e) { state.opts.baseChecked = e.target.checked; render(); }
          }),
          h('div', {}, [
            h('strong', {}, ['Add Protection Base?']),
            document.createTextNode(' Grass isn’t heat-sensitive, but a base keeps the pit level and clean between burns.')
          ])
        ]);
        toggleBase.querySelector('input').checked = state.opts.baseChecked !== false;
      }

      var toggles = h('div', { class: 'fmp__toggles' }, toggleBase ? [toggleCit, toggleBase] : [toggleCit]);

      var savedRow = pkgSave > 0
        ? h('div', { class: 'fmp__saves' }, [
            h('span', {}, ['You save']),
            h('span', {}, [money(pkgSave)])
          ])
        : null;

      var cta = h('button', {
        class: 'fmp__btn fmp__btn--primary fmp__btn--full fmp__btn--large',
        type: 'button',
        onclick: function () { addToCart(lines, cta); }
      }, ['Add my package to cart · ' + money(pkgTotal)]);

      var pitImg = (variants[rec.pitSku] || {}).img;
      var heroDom = pitImg
        ? h('div', { class: 'fmp__rec-hero' }, [
            h('img', {
              src: pitImg,
              alt: variants[rec.pitSku].title,
              loading: 'lazy',
              decoding: 'async'
            })
          ])
        : null;

      var card = h('div', { class: 'fmp__result' }, [
        heroDom,
        h('p', { class: 'fmp__rec-eyebrow' }, ['Your ECOFUEGO recommendation']),
        h('h3', { class: 'fmp__rec-headline' }, [hl]),
        h('p', { class: 'fmp__rec-why' }, [why]),
        h('div', { class: 'fmp__bundle' }, [
          h('div', { class: 'fmp__bundle-head' }, [
            h('span', {}, ['Your package']),
            h('span', { class: 'fmp__stock' }, [''] /* no stock or ship claim here (Gabe, 2026-10-13); the US was told "in stock" for pre-order pits */)
          ]),
          linesDom,
          h('div', { class: 'fmp__totals' }, [
            h('span', {}, ['Package total']),
            h('span', {}, [money(pkgTotal)])
          ]),
          savedRow
        ]),
        toggles,
        h('div', { class: 'fmp__cta-row' }, [cta]),
        h('button', {
          class: 'fmp__reset',
          type: 'button',
          onclick: function () {
            clearSaved();
            state.answers = {};
            state.email = '';
            state.opts = { citronella: false, baseChecked: true };
            state.step = 0;
            render();
          }
        }, ['Start over'])
      ]);
      stage.appendChild(card);
    }

    function addToCart(lines, btnEl) {
      if (state.submitting) return;
      state.submitting = true;
      var origLabel = btnEl.textContent;
      btnEl.textContent = 'Adding…';
      btnEl.disabled = true;
      var items = lines.map(function (l) { return { id: variants[l.sku].id, quantity: l.qty }; });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart add failed (' + r.status + ')');
        return r.json();
      }).then(function () {
        window.location.href = '/cart';
      }).catch(function (err) {
        console.error('[fmp] cart add failed', err);
        btnEl.textContent = 'Something went wrong — try again';
        btnEl.disabled = false;
        state.submitting = false;
      });
    }

    function fireKlaviyo(a, rec, totalGbp, email) {
      if (!klaviyoKey) return;
      var eventProps = {
        frequency: a.frequency,
        setting: a.setting,
        travel: a.travel,
        surface: a.surface,
        recommended_pit: rec.pitSku,
        recommended_bundle_total_gbp: Number(totalGbp.toFixed(2))
      };
      var profileProps = {
        pit_frequency: a.frequency,
        pit_setting: a.setting,
        pit_travel: a.travel,
        pit_surface: a.surface,
        pit_recommended_sku: rec.pitSku
      };
      var profileAttrs = { properties: profileProps };
      if (email) profileAttrs.email = email;
      var eventPayload = {
        data: {
          type: 'event',
          attributes: {
            properties: eventProps,
            metric: { data: { type: 'metric', attributes: { name: 'Find My Pit Completed' } } },
            profile: { data: { type: 'profile', attributes: email ? profileAttrs : { properties: profileProps } } }
          }
        }
      };
      // Fire event
      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(klaviyoKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
        body: JSON.stringify(eventPayload)
      }).then(function (r) {
        if (!r.ok && !email) console.warn('[fmp] klaviyo event returned', r.status);
      }).catch(function (e) { console.warn('[fmp] klaviyo event error', e); });

      if (email && listId) {
        var subPayload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Find My Pit Quiz',
              profile: { data: { type: 'profile', attributes: { email: email, properties: profileProps } } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        };
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(klaviyoKey), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
          body: JSON.stringify(subPayload)
        }).then(function (r) {
          if (!r.ok) console.warn('[fmp] klaviyo subscribe returned', r.status);
        }).catch(function (e) { console.warn('[fmp] klaviyo subscribe error', e); });
      } else if (!email) {
        console.warn('[fmp] no email captured; skipping list subscribe and email-only profile properties');
      }
    }

    // Boot state — land straight on Q1, or resume mid-quiz if saved.
    if (state.answers && Object.keys(state.answers).length > 0) {
      state.step = Math.min(Object.keys(state.answers).length, QUESTIONS.length);
    } else {
      state.step = 0;
    }
    render();
    // Every render after this one is the result of something the visitor did, so it may take
    // focus. See renderGate().
    booted = true;
  }

  function boot() {
    document.querySelectorAll('[data-fmp-root]').forEach(initInstance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
